import $ from 'jquery';

const Tab = function () {
  // TAB
  if (document.getElementById("js-tabs") != null || document.getElementById("tabs") != null) {
    const btn = $('.c-tab__btn');
    const btn02 = $('.tab__btn');
    btn.on('click', function () {
      tabAction($(this),btn)
    });
    btn02.on('click', function () {
      tabAction($(this),btn02)
    });
    function tabAction(self, btn) {
      if (!(self.hasClass('is-active'))) {
        $('.c-tab__item').removeClass('is-active');
        btn.removeClass('is-active');
        self.addClass('is-active');
        self.parent().addClass('is-active');
        let num = self.attr('data-tab');
        const el = $('.c-tab__el');
        const el02= $('.tab__el');
        el.removeClass('is-active');
        el02.removeClass('is-active');

        $(`#${num}`).addClass('is-active');
      }
    }
  }
}

export default Tab;


// WEBPACK FOOTER //
// ./src/recruit/js/tab.js